import { memo } from 'react';

import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';

const TrlKeys = {
    title: 'employer.price2.service.entry.CLKM',
};

// Пример: Продвижение вакансии в Clickme
const Title: TranslatedComponent = ({ trls }) => <span data-qa="cart-item__title">{trls[TrlKeys.title]}</span>;

export default memo(translation(Title));
